import { escapeRegExp } from "lodash";
import { FC } from "react";
import { useRecoilValue } from "recoil";

import { decorateWithMark, Highlight } from "@ryde/controls";
import {
  getIsCalendarPassengerPhoneRestrictedBySearch,
  getIsCalendarPassengerWorkerCodeRestrictedBySearch,
  IBookingCalendarPassengerDto,
  NO_VALUE_DISPLAY,
  tableSearchAF,
} from "@ryde/shared";

interface IResolvedPassengerNameProps {
  passenger: IBookingCalendarPassengerDto | null;
}

export const ResolvedPassengerName: FC<IResolvedPassengerNameProps> = ({
  passenger,
}) => {
  const searchValue = useRecoilValue(tableSearchAF("booking"));

  const resolvedPassengerName = passenger?.passengerName ?? NO_VALUE_DISPLAY;
  const isHighLightedPartOfName =
    searchValue?.length &&
    String(resolvedPassengerName)
      .toLowerCase()
      .match(escapeRegExp(searchValue).toLowerCase());

  const isWorkerCodeRestrictedBySearch =
    getIsCalendarPassengerWorkerCodeRestrictedBySearch({
      searchValue,
      passenger,
    });
  const isPhoneRestrictedBySearch =
    getIsCalendarPassengerPhoneRestrictedBySearch({
      searchValue,
      passenger,
    });
  const isHighLightedFullName =
    searchValue?.length &&
    (isWorkerCodeRestrictedBySearch || isPhoneRestrictedBySearch);

  if (isHighLightedPartOfName) {
    return <span>{decorateWithMark(resolvedPassengerName, searchValue)}</span>;
  }

  if (isHighLightedFullName) {
    return <Highlight>{resolvedPassengerName}</Highlight>;
  }

  return <span>{resolvedPassengerName}</span>;
};
